// 我的彩票（订单列表，带状态切换 Tab）
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Container, Box, Tabs, Tab, CircularProgress, Typography, Card, CardContent,
} from '@mui/material';
import RlPageHeader from '../../components/real-lottery/RlPageHeader';
import OrderCard from '../../components/real-lottery/OrderCard';
import { getCurrentRlUser } from '../../components/real-lottery/useRlUser';
import { listRlOrders, getRlRedeemStatus } from '../../services/realLotteryApi';

const TABS = [
  { value: 'all', label: '全部' },
  { value: 'progress', label: '进行中' },
  { value: 'won', label: '已中奖' },
  { value: 'lost', label: '未中奖' },
  { value: 'failed', label: '未出票' },
];

export default function RealLotteryOrdersPage() {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initStatus = params.get('status') || 'all';
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState(initStatus);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (userId, status) => {
    setLoading(true);
    const res = await listRlOrders({ userId, status, page: 1, pageSize: 50 });
    if (res.success) setOrders(res.data.list);
    setLoading(false);
  }, []);

  useEffect(() => {
    const u = getCurrentRlUser();
    if (!u) { history.replace('/login-v2'); return; }
    setUser(u);
    load(u.userId, tab);
  }, [tab]);

  const handleAction = async (action, order) => {
    if (action === 'refreshRedeem') {
      await getRlRedeemStatus(order.outTradeNo);
      if (user) load(user.userId, tab);
    }
  };

  return (
    <Box sx={{ backgroundColor: '#f5f5f7', minHeight: '100vh', pb: 4 }}>
      <RlPageHeader title="我的彩票" />
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          backgroundColor: '#fff',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        {TABS.map((t) => <Tab key={t.value} value={t.value} label={t.label} />)}
      </Tabs>

      <Container maxWidth="sm" sx={{ pt: 2 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
            <CircularProgress />
          </Box>
        ) : orders.length === 0 ? (
          <Card sx={{ borderRadius: 2 }}>
            <CardContent sx={{ textAlign: 'center', py: 6 }}>
              <Typography color="text.secondary">暂无相关订单</Typography>
            </CardContent>
          </Card>
        ) : (
          orders.map((o) => <OrderCard key={o.outTradeNo} order={o} onAction={handleAction} />)
        )}
      </Container>
    </Box>
  );
}
